module.exports = __webpack_public_path__ + "img/组 8406.03b4e7e0.png";